import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const StudentWeeklyPlanService = {
    List(j, callback, wait) {
        Ajax.Api(MethodType.Post, `${Enums.SERVICE.STUDENT_WEEKLY_PLAN}/filter/all`, j, wait).then((data) => {
            callback(data);
        });
    },
    By(j, callback, wait) {
        Ajax.Api(MethodType.Post, `${Enums.SERVICE.STUDENT_WEEKLY_PLAN}/filter${j.studentId > 0 ? "/student" : ""}`, j, wait).then((data) => {
            callback(data);
        });
    },
    ByDay(j, callback, wait) {
        Ajax.Api(MethodType.Post, `${Enums.SERVICE.STUDENT_WEEKLY_PLAN}/filter/day${j.studentId > 0 ? "/student" : ""}`, j, wait).then((data) => {
            callback(data);
        });
    },
    ByPreview(j, callback, wait) {
        Ajax.Api(MethodType.Post, `${Enums.SERVICE.STUDENT_WEEKLY_PLAN}/filter/preview${j.studentId > 0 ? "/student" : ""}`, j, wait).then((data) => {
            callback(data);
        });
    },
    ListLessonAnalysis(j, callback, wait) {
        Ajax.Api(MethodType.Post, `${Enums.SERVICE.STUDENT_WEEKLY_PLAN}/filter/lesson-analysis${j.studentId > 0 ? "/student" : ""}`, j, wait).then((data) => {
            callback(data);
        });
    },
    Save(j, callback, wait) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.STUDENT_WEEKLY_PLAN, j, wait).then((data) => {
            callback(data);
        });
    },
    ChangeDay(j, callback, wait) {
        Ajax.Api(MethodType.Put, `${Enums.SERVICE.STUDENT_WEEKLY_PLAN}/change-day`, j, wait).then((data) => {
            callback(data);
        });
    },
    ChangeWorkMaxCount(j, callback, wait) {
        Ajax.Api(MethodType.Put, `${Enums.SERVICE.STUDENT_WEEKLY_PLAN}/change-work-max-count`, j, wait).then((data) => {
            callback(data);
        });
    },
    ChangeQuestionMaxCount(j, callback, wait) {
        Ajax.Api(MethodType.Put, `${Enums.SERVICE.STUDENT_WEEKLY_PLAN}/change-question-max-count`, j, wait).then((data) => {
            callback(data);
        });
    },
    ChangeDayWorkCount(j, callback, wait) {
        Ajax.Api(MethodType.Put, `${Enums.SERVICE.STUDENT_WEEKLY_PLAN}/change-day-work-count`, j, wait).then((data) => {
            callback(data);
        });
    },
    ChangeTeacherPoint(j, callback, wait) {
        Ajax.Api(MethodType.Put, `${Enums.SERVICE.STUDENT_WEEKLY_PLAN}/change-teacher-point`, j, wait).then((data) => {
            callback(data);
        });
    },
}; 